import { gql, useMutation } from '@apollo/client';
import { Obj } from '@livecontrol/core-utils';
import type { MutationResult } from '@livecontrol/scheduler/store';
import { Errors } from '@livecontrol/scheduler/store';
import { useCallback } from 'react';

const MUTATION = gql`
mutation GenerateAssetSignedUrl($clientId: Int!, $assetId: Int!) {
  GenerateAssetSignedUrl(client_id: $clientId, asset_id: $assetId) {
    destination_url
    error
    upload_url
  }
}
`;

interface TVariables {
    clientId: number;
    assetId: number;
}

interface TData {
    GenerateAssetSignedUrl: {
        destination_url?: string;
        error?: boolean;
        upload_url?: string;
    };
}

type Args = Partial<TVariables>;
type AssetSignedUrl = TData['GenerateAssetSignedUrl'];

export const useGenerateUrl = (): [
    (args: Args) => Promise<AssetSignedUrl | undefined>,
    MutationResult<AssetSignedUrl>
] => {
    const [mutation, { loading, called, data }] = useMutation<TData, TVariables>(MUTATION);

    return [
        useCallback(async (args: Args) => {
            let data_: AssetSignedUrl |  undefined;

            try {

                if (!Obj.isHydrated(args)) {
                    throw Errors.badRequest();
                }

                const response = await mutation({ variables: args });

                data_ = response.data?.GenerateAssetSignedUrl;
            } catch {
                //
            }

            return data_;
        }, [mutation]),
        {
            loading,
            called,
            data: data?.GenerateAssetSignedUrl
        }
    ];
};
